import React from "react"
import { createMarkup } from "utils/createMarkup"
import {
  HtmlTable as ContentfulTable,
  HtmlTableBody,
  HtmlTableThead,
  HtmlTd,
} from "../../../theme/components/Table"

type Row = [cell: string[]]
export type TableProps = {
  tableData: Row[] | Row
  tableId: string
  colWidths?: Row
}

export const HtmlTable: React.FC<TableProps> = ({
  tableData,
  tableId,
  colWidths,
}) => {
  const tableHead = tableData[0]
  const firstRow = tableData[1]
  const defaultColWidth = `${Math.floor(100 / tableHead.length)}%` // This will evenly generate columns
  return (
    <ContentfulTable width="100%">
      <HtmlTableThead>
        <tr>
          {tableHead.map((cell, idx) => {
            const cellId = `${tableId}-thead-${idx}`
            return (
              <HtmlTd
                key={cellId}
                width={
                  colWidths && colWidths[0].length > 0
                    ? colWidths[idx]
                    : defaultColWidth
                }
                textAlign={
                  !Number.isNaN(Number(firstRow[idx])) ? "center" : "left"
                }
              >
                {cell}
              </HtmlTd>
            )
          })}
        </tr>
      </HtmlTableThead>
      <HtmlTableBody>
        {tableData.map((row, rowId) => {
          if (rowId === 0) {
            return
          }
          const rowNo = `${tableId}-row-${rowId + 1}`
          return (
            <tr key={rowNo}>
              {row.map((cell, idx) => {
                const cellId = `${tableId}-cell-${idx}`
                return (
                  <HtmlTd
                    key={cellId}
                    textAlign={!Number.isNaN(Number(cell)) ? "center" : "left"}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={createMarkup(cell)}
                  />
                )
              })}
            </tr>
          )
        })}
      </HtmlTableBody>
    </ContentfulTable>
  )
}
